import classNames from 'classnames';
import { LISTING_STATUS } from '../../../constants/listing.constants';
import {
  LISTING_STATE_CLOSED,
  LISTING_STATE_DRAFT,
  LISTING_STATE_PUBLISHED,
} from '../../../util/types';

import css from './ManageListingCard.module.css';
import { FormattedMessage } from 'react-intl';

const LISTING_STATE_TO_LABEL = {
  [LISTING_STATE_DRAFT]: <FormattedMessage id="General.listing.status.draft" />,
  [LISTING_STATE_PUBLISHED]: <FormattedMessage id="General.listing.status.forSale" />,
  [LISTING_STATE_CLOSED]: <FormattedMessage id="General.listing.status.unavailable" />,
};
const LISTING_STATUS_TO_LABEL = {
  [LISTING_STATUS.DRAFT]: LISTING_STATE_TO_LABEL[LISTING_STATE_DRAFT],
  [LISTING_STATUS.FOR_SALE]: LISTING_STATE_TO_LABEL[LISTING_STATE_PUBLISHED],
  [LISTING_STATUS.UNAVAILABLE]: LISTING_STATE_TO_LABEL[LISTING_STATE_CLOSED],
  [LISTING_STATUS.UNDER_NEGOTIATION]: (
    <FormattedMessage id="General.listing.status.underNegotiation" />
  ),
  [LISTING_STATUS.SOLD]: <FormattedMessage id="General.listing.status.sold" />,
  [LISTING_STATUS.CANCELED]: <FormattedMessage id="General.listing.status.canceled" />,
};

const ListingStatus = props => {
  const { currentListing, isAbsolute = true, className } = props;
  const { state, publicData, metadata } = currentListing?.attributes || {};
  const { status } = publicData || {};
  const { isPaused } = metadata || {};

  const isClosed = state === LISTING_STATE_CLOSED;
  const isDraft = state === LISTING_STATE_DRAFT;
  const isActive = state === LISTING_STATE_PUBLISHED;

  const label = isPaused ? (
    <FormattedMessage id="General.listing.status.paused" />
  ) : !!status ? (
    LISTING_STATUS_TO_LABEL[status]
  ) : (
    LISTING_STATE_TO_LABEL[state]
  );

  return (
    <span
      className={classNames(
        css.stateLabel,
        css.label,
        {
          [css.draftLabel]: isDraft,
          [css.activeLabel]: isActive,
          [css.closedLabel]: isClosed,
          [css.autoPausedLabel]: isPaused,
          [css.relativeLabel]: !isAbsolute,
        },
        className
      )}
    >
      {label}
    </span>
  );
};

export default ListingStatus;
